import { useEffect } from 'react';
import { PushNotifications } from '@capacitor/push-notifications';
import { Device } from '@capacitor/device';

import { getPushToken, registerPushDevice, sendPushTokenToBackend, setupPushListeners } from '../pushNotifications';

export default function usePushNotifications(authenticated: boolean, token?: string) {
  useEffect(() => {
    setupPushListeners();
  }, []);

  useEffect(() => {
    if (!authenticated || !token) {
      return;
    }

    let listenerHandle: { remove: () => Promise<void> } | undefined;
    let cancelled = false;

    const run = async () => {
      const info = await Device.getInfo();
      if (info.platform === 'web') {
        return;
      }

      await registerPushDevice();

      const stored: any = await getPushToken();
      const currentToken = stored?.token;
      if (currentToken) {
        await sendPushTokenToBackend(currentToken, token);
      }

      const handle = await PushNotifications.addListener('registration', async (newToken) => {
        if (!newToken?.value) {
          return;
        }
        await sendPushTokenToBackend(newToken.value, token);
      });

      if (cancelled) {
        handle.remove?.();
        return;
      }
      listenerHandle = handle;
    };

    run();

    return () => {
      cancelled = true;
      listenerHandle?.remove?.();
    };
  }, [authenticated, token]);
}
